import { POPOVER_MENU_DEFS } from 'components/SideNavbar/SidebarPopover/SidebarPopover.defs';

type PopoverSectionKey = keyof typeof POPOVER_MENU_DEFS;

function normalizePopoverPath(location: string): string {
  if (location.startsWith('/')) return location;
  return `/${location}`;
}

function pathMatches(pathname: string, location: string): boolean {
  const p = normalizePopoverPath(location);
  return pathname === p || pathname.startsWith(`${p}/`);
}

/**
 * Which sidebar popover section owns the current route (any link in that popover’s menu).
 * Mirrors Lead Revival’s `pathname.includes('/leadRevival')` pattern for every section.
 */
export default function getActivePopoverFromPathname(
  pathname: string,
): PopoverSectionKey | undefined {
  const keys = Object.keys(POPOVER_MENU_DEFS) as PopoverSectionKey[];
  for (const key of keys) {
    const sections = POPOVER_MENU_DEFS[key];
    for (const sectionLinks of Object.values(sections)) {
      for (const link of sectionLinks) {
        if (pathMatches(pathname, link.location)) {
          return key;
        }
        if (link.suffixIconLocation && pathMatches(pathname, link.suffixIconLocation)) {
          return key;
        }
      }
    }
  }
  if (pathMatches(pathname, '/campaign_creation') || pathMatches(pathname, '/campaign_editing')) {
    return 'campaigns';
  }
  return undefined;
}
